import { getLatestRunState } from '../../components/ProcessLogSummary';

export const ALL_POST_CHANNELS = ['LinkedIn', 'Naukri'];

export const hasExplicitPostingSuccessLog = (logs = []) =>
  (logs || []).some((log) => {
    const content = String(log?.message || log?.logMessage || '').toLowerCase();
    return (
      content.includes('posted successfully on linkedin') ||
      content.includes('posted successfully on naukri') ||
      content.includes('job posted successfully on linkedin') ||
      content.includes('job posted successfully on naukri') ||
      content.includes('job posted successfully!')
    );
  });

export const hasLatestRunPostingFailure = (logs = []) => {
  const latestRunState = getLatestRunState(logs);
  return Boolean(latestRunState.lastFailure && latestRunState.terminalShouldWin);
};

export const hasLatestRunPostingSuccess = (logs = []) => {
  const latestRunState = getLatestRunState(logs);
  return Boolean(
    (latestRunState.latestTerminalIsSuccess && latestRunState.terminalShouldWin) ||
      hasExplicitPostingSuccessLog(logs),
  );
};

export const resolvePostingProcessingFlag = (logs = [], processing = false) => {
  if (!processing) return false;
  const latestRunState = getLatestRunState(logs);
  if (latestRunState.lastFailure && latestRunState.terminalShouldWin) return false;
  if (latestRunState.latestTerminalIsSuccess && latestRunState.terminalShouldWin) return false;
  return true;
};

export const getPostingChannelsFromSourcingPreferences = (channels = []) => {
  const normalizedChannels = Array.isArray(channels)
    ? channels.map((channel) => String(channel || '').trim().toLowerCase()).filter(Boolean)
    : [];

  const postingChannels = [];

  if (normalizedChannels.some((channel) => channel.includes('linkedin'))) {
    postingChannels.push('LinkedIn');
  }

  if (normalizedChannels.some((channel) => channel.includes('naukri'))) {
    postingChannels.push('Naukri');
  }

  return postingChannels.length > 0 ? postingChannels : [...ALL_POST_CHANNELS];
};

export const parseExperienceRange = (experience) => {
  if (!experience) return { min: 1, max: 3 };

  const expStr = String(experience).toLowerCase().trim();

  const rangeMatch = expStr.match(/(\d+)\s*(?:-|to)\s*(\d+)/);
  if (rangeMatch) {
    const min = parseInt(rangeMatch[1], 10);
    const max = parseInt(rangeMatch[2], 10);
    return { min: min || 1, max: max || min + 2 };
  }

  const plusMatch = expStr.match(/(\d+)\s*\+/);
  if (plusMatch) {
    const min = parseInt(plusMatch[1], 10);
    return { min: min || 1, max: min + 3 };
  }

  const singleMatch = expStr.match(/(\d+)/);
  if (singleMatch) {
    const val = parseInt(singleMatch[1], 10);
    return { min: val || 1, max: val + 2 };
  }

  return { min: 1, max: 3 };
};

export const formatLastUpdated = (value = new Date()) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return 'Recently';
  return date.toLocaleString([], {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
};

export const getLatestSessionTimestamp = (session) =>
  session?.last_message_at ||
  session?.lastMessageAt ||
  session?.updated_at ||
  session?.updatedAt ||
  session?.created_at ||
  session?.createdAt ||
  null;

export const isLocalUiOnlyChatCommand = (message = '') => {
  const normalized = String(message || '').trim().toLowerCase();
  if (!normalized) return false;
  return /^(show|view|open)\s+(all\s+)?candidates?$/.test(normalized) ||
    /^(show|view|open)\s+candidate\s+list$/.test(normalized) ||
    /^(show|view|open)\s+jd$/.test(normalized) ||
    /^job\s+description$/.test(normalized);
};

export const isLocalUiNavigationHint = (message = '') => {
  const normalized = String(message || '').trim().toLowerCase();
  return normalized === '📋 check the candidate list in the right sourcing panel.'.toLowerCase();
};
